<template lang="pug">
  .filters-block
    lei-popover.filters-label-tooltip-box(:text="tooltips.searchBarAddFilter")
      label.filters-label Apply filters:
    .filters
      lei-filter(v-for="filter in simpleSearchFilters",
      :filter="filter",
      :key="filter.id",
      :initialValue="isCountry(filter) ? getValueForResource(filter.value, countries) : filter.value",
      :items="isCountry(filter) ? countries : filter.enum",
      :name="filter.label",
      :class="'filter-' + filter.label"
      @choose="chooseFilter",
      @remove="removeFilter",
      :get-label='isCountry(filter) ? getLabelForCountries : getLabel')
        template(slot-scope="{choice}" slot="choice" v-if="isCountry(filter)")
          a.choice
            img.flag(:src="getCountryFlagByCode(choice ? choice.code : null)")
            | {{getLabelForCountries(choice)}}
        template(slot-scope="{item}" v-if="isCountry(filter)")
          .autocomplete-item
            img.flag(:src="getCountryFlagByCode(item ? item.code : null)")
            | {{getLabelForCountries(item)}}
    .clear-block
      lei-btn.config-btn(@click="searchDefault" type="turquoise-keyline", size="sm", fill) Clear filters
</template>
<script>
import { getLabelForResource, getValueForResource, } from '../../utils/resources'
import { getCountryFlagByCode, } from '../../utils/countries'
import { mapGetters, mapMutations, mapActions, } from 'vuex'
import { APPLY_FILTER, CLEAR_PARAMS, } from '../../store/modules/search/mutations-types'
import routerSearch from '../../mixins/router-search-mixin'
import simple from '../../constants/tooltips/simple'
import LeiPopover from '../lei-components/LeiPopover'
import LeiFilter from '../lei-components/inputs/LeiFilter'
import LeiBtn from '../lei-components/LeiBtn'
import { EventBus, } from '../../event-bus'

export default {
  components: {
    LeiBtn,
    LeiPopover,
    LeiFilter,
  },
  mixins: [ routerSearch, ],
  data () {
    return {
      country: '',
      countries: [],
      tooltips: simple,
    }
  },
  computed: {
    ...mapGetters('search', [ 'simpleSearchFilters', ]),
  },
  async created () {
    this.countries = await this.getResources('countries')
  },
  methods: {
    isCountry (filter) {
      return filter.id === 'LEIREC_ADDRESSES_COUNTRY'
    },
    getCountryFlagByCode,
    chooseFilter ({ item, filter, }) {
      this.applyFilter({
        value: this.isCountry(filter) ? item.code : item,
        filter,
      })
      this.routerSearch()
    },
    removeFilter ({ filter, }) {
      this.applyFilter({
        value: null,
        filter,
      })
      this.routerSearch()
    },
    getLabel (item) {
      return item
    },
    getValueForResource,
    getLabelForCountries (item) {
      return getLabelForResource('countries', item)
    },
    searchDefault () {
      EventBus.$emit('clear-list')
      this.clearParams()
      this.routerSearch()
    },

    ...mapMutations('search', {
      applyFilter: APPLY_FILTER,
      clearParams: CLEAR_PARAMS,
    }),
    ...mapActions('search', [ 'getResources', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .filter-Status .filter-wrap .autocomplete-list,
  .filter-General .filter-wrap .autocomplete-list
    max-height: none !important
  .filters-block
    display flex
    align-items center

    .filters
      align-items center
      display flex
      flex-wrap wrap

      .lei-filter
        margin 0 10px 0 0

      .flag
        width 20px
        margin-right 10px
      .category
        background-color $turquoise-color
        justify-content center


    .filters-label-tooltip-box
      box-sizing border-box
      min-width 100px
      margin-right 25px

    .filters-label
      line-height 40px
      font-size .75rem
      font-weight 600
      color $default-color-bold
    .clear-block
      min-width 125px
      justify-content flex-end
      display flex
      flex 1
      font-weight 600

  @media (max-width: $laptop)
    .simple-form
      margin 10px 0 0

  @media (max-width: $tablet)
    .filters-block
      flex-direction column
      align-items stretch

      .filters
        margin 0 -20px
        flex-direction column
      .filters-label
        margin-right 0
      .clear-block
        margin 15px 0
</style>



// WEBPACK FOOTER //
// src/components/search-components/SimpleFilters.vue